// src/state/activeEditStore.js
const KEY = "veya_active_edit_v1";

export function getActiveEditId() {
  try {
    return localStorage.getItem(KEY);
  } catch {
    return null;
  }
}

export function setActiveEditId(idOrNull) {
  try {
    if (!idOrNull) localStorage.removeItem(KEY);
    else localStorage.setItem(KEY, String(idOrNull));
  } catch {}
}